/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const solutionValueDriverDtoSchema = z.object({
  driver: z.optional(z.string()),
  whatChanges: z.optional(z.string()),
});
